// @flow
import { useContext } from 'react';
import { PREVIOUS_CONTRACT_DETAILS_ENUMS } from '@components/renewal-automation/constants';
import { getPreviousACVFromPreviousTCVAndDealDuration } from '@components/renewal-automation/utils';

import { EstimateContext } from '../contexts/EstimateContext';

export const usePreviousContractDetails = () => {
  const estimate = useContext(EstimateContext);
  const previousContractDetails = estimate?.[PREVIOUS_CONTRACT_DETAILS_ENUMS.BE_FIELD_NAME] ?? null;

  const {
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.ARR.BACKEND_NAME]: arr = null,
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.TCV.BACKEND_NAME]: tcv = null,
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.DEAL_DURATION.BACKEND_NAME]: dealDurationInYears = null,
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.START_DATE.BACKEND_NAME]: startDate = null,
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.END_DATE.BACKEND_NAME]: endDate = null,
    [PREVIOUS_CONTRACT_DETAILS_ENUMS.RATE_CARD.BACKEND_NAME]: rateCard = null,
  } = previousContractDetails ?? {};

  const acv = getPreviousACVFromPreviousTCVAndDealDuration(tcv, dealDurationInYears);

  return {
    previousContractDetails,
    acv,
    arr,
    tcv,
    dealDurationInYears,
    startDate,
    endDate,
    rateCard,
  };
};

/**
 * Extracts the previous ARR (Annual Recurring Revenue) from an estimate object.
 *
 * @param {Object} estimate - The estimate object
 * @returns {number} The previous ARR
 * @throws {Error} If previous ARR is not present in the estimate
 */
export const getPreviousARRFromEstimate = (estimate) => {
  const previousARR =
    estimate?.[PREVIOUS_CONTRACT_DETAILS_ENUMS.BE_FIELD_NAME]?.[
      PREVIOUS_CONTRACT_DETAILS_ENUMS.ARR.BACKEND_NAME
    ];
  if (!previousARR) {
    throw new Error('previous ARR is not present in the estimate');
  }
  return previousARR;
};
